import { render, staticRenderFns } from "./AcademyShowAllCards.vue?vue&type=template&id=1201a5ac&scoped=true&"
import script from "./AcademyShowAllCards.vue?vue&type=script&lang=js&"
export * from "./AcademyShowAllCards.vue?vue&type=script&lang=js&"
import style0 from "./AcademyShowAllCards.vue?vue&type=style&index=0&id=1201a5ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1201a5ac",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCardText, BCard, BCardGroup, BButton} from 'bootstrap-vue'
    installComponents(component, {BCardText, BCard, BCardGroup, BButton})
    

export default component.exports